import cls from './NotFoundPage.module.scss';

export const NotFoundPage = () => (
  <div className={cls.exceptionWrapper}>
    <p>404...</p>
  </div>
);
